import React, { useState } from "react";
import { Info } from "lucide-react";

const DEMO_MODE = process.env.REACT_APP_DEMO_MODE === "true";

export default function DemoNotice() {
  const [dismissed, setDismissed] = useState(
    localStorage.getItem("sentralia_demo_notice") === "hidden"
  );

  if (!DEMO_MODE || dismissed) return null;

  const dismiss = () => {
    localStorage.setItem("sentralia_demo_notice", "hidden");
    setDismissed(true);
  };

  return (
    <div className="w-full bg-indigo-600 text-white px-4 py-3 flex items-start gap-3 text-sm shadow-md z-50">
      <Info className="w-5 h-5 mt-0.5 shrink-0" />
      
      <div className="flex-1">
        <strong>Sentralia Demo Mode</strong>
        <div className="opacity-90">
          This page is a live demo of Sentralia using <b>mock data</b>. No real APIs, user data,
          moderation actions, or analytics are performed. Auth workflows are disabled, you are viewing this page POV of an Admin/Owner.
        </div>
      </div>

      <button
        onClick={dismiss}
        className="ml-4 text-white/80 hover:text-white transition"
        aria-label="Dismiss demo notice"
      >
        ✕
      </button>
    </div>
  );
}
